module.exports = __webpack_public_path__ + "static/media/lawyer-conveyancer.1751266b.png";